module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/slide-0.76a03427.webp";